export default __webpack_public_path__ + "static/media/instruction-img-1.562db979.png";